<template>
  <div>
    <b-modal id="modalEditChatSettings" ref="modalEditChatSettings" @shown="shown"
      :title="$t('Tech support chat setting')" hide-footer>
      <div  v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id != 0" disabled label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :disabled="editItem.id != 0" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.group_id" :options="groups" :disabled="editItem.id != 0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
           <b-form-checkbox switch size="lg" v-model="editItem.is_enabled" value="1" unchecked-value="0" />
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditChatSettings')" size="md"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    save () {
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_CHAT_SETTINGS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_CHAT_SETTINGS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_CHAT_SETTINGS')
          this.$bvModal.hide('modalEditChatSettings')
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      if (this.editItem.id === 0 && this.groups.length) {
        this.editItem.group_id = this.groups[0].value
      }
    }
  },
  computed: {
    groups () {
      let res = []
      for (let el of this.$store.getters['Users/GROUPS']) {
        if (this.editItem.id === 0) {
          let isAlreadyHas = false
          for (let elPS of this.chatSetting) {
            if (elPS.group_id === el.group_id) {
              isAlreadyHas = true
              break
            }
          }
          if (isAlreadyHas) {
            continue
          }
        }
        let newEl = {}
        newEl.value = el.group_id
        newEl.text = el.group_name
        res.push(newEl)
      }
      if (this.editItem.id === 0) {
        let isAlreadyHas = false
        for (let elPS of this.chatSetting) {
          if (elPS.group_id === 0) {
            isAlreadyHas = true
            break
          }
        }
        if (!isAlreadyHas) {
          res.push({value: 0, text: this.$t('All')})
        }
      } else {
        res.push({value: 0, text: this.$t('All')})
      }
      return res
    },
    chatSetting () {
      return this.$store.getters['Settings/CHAT_SETTINGS']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_CHAT_SETTINGS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/chat/editModal.vue